module.exports = __webpack_public_path__ + "static/media/1.cb281dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = 68
// module chunks = 0